// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82328a97","227":"6ff1bc77","352":"81782c43","357":"c1ffaebc","812":"4bfd0c83","902":"69f17d86"}[chunkId] + ".chunk.js";
};